import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import 'core-js'

$("document").ready(function () {
  if ($('.formContainer').length > 0) {
    var currentStep = 1; //var baseInstall = 990.00;

    $('#tableData-house').hide();
    var input_4_63_val = $("#input_4_63").val();
    var input_4_64_val = $("#input_4_64").val();
    $("#input_4_64").val('');
    $("#input_4_63").val('');
    var baseInstall = 0.00;
    var baseNet = 69.90;
    var productPrice = 0.00;
    var telefonPrice = 0.00;
    var tvPaket = 0.00;
    var uploadBoost = 0.00;
    var routerAuswahl = 0.00;
    var bankPrice = 0.00;
    var postPrice = 0.00;
    var monthlyprice = 0.00;
    var onceprice = 0.00;
    $('.gform_footer').append('<span class="hider"></span>');
    $('.hider').click(function () {
      $('#message-4').html('Bitte bestätigen Sie unsere AGB und Datenschutzerklärung!');
      $('#message-4').show();
      $('#input_4_62').parent().addClass('error');
      $('html,body').scrollTop(0);
      return false;
    });
    $("#choice_4_6_1").attr("checked", true);
    /*$('.hideInactive input').each(function(i) {
      this.disabled = true;
    });*/

    $("#choice_4_6_1").click(function () {
      $("#choice_4_6_1").attr("checked", true);
      return false;
    });
    $(".productItem a").click(function () {
      // choose product
      var product = $(this).data('product');
      var price = $(this).data('price');
      var label = $(this).data('label');
      var chosen = $(this).data('chosen');
      $(".productItem a").parent().removeClass('active');
      $(this).parent().addClass('active');
      $('.chosenProduct .productItem').removeClass('active');
      $('#product-' + product).addClass('active');
      $('.priceTable .imageBox').removeClass('productImg-1');
      $('.priceTable .imageBox').removeClass('productImg-2');
      $('.priceTable .imageBox').removeClass('productImg-3');
      $('.priceTable .imageBox').removeClass('productImg-4');
      $('.priceTable .imageBox').addClass('productImg-' + product);
      $('#tableData-product .cellLabel').html(label);
      $('#tableData-product .cellData').html(price.replace(".", ","));
      productPrice = price;
      currentStep = 2;
      $('.formStep ul li:nth-child(2) a').removeClass('inactive');
      summarize();
      /*XXXX
      
      input_4_24 data-4 second
      input_4_21 data-3 f
      input_4_22 data-3 s
      */
      ////console.log(onceprice);
      ////console.log(monthlyprice);
      // Empty fields

      $("input:text").each(function (i) {
        $(this).val('');
      }); //SETTING IT UP

      $('.chosen input').val(chosen);
      $('#input_4_80').val('Als Eigentümer bin ich damit einverstanden, dass die Glasfaser Direkt GmbH auf dem vertragsrelevanten Grundstück und in den vorhandenen bzw. entstehenden Geb uden alle erforderlichen Bauteile errichtet, um die Verbindung zum Telekommunikationsnetz der Glasfaser Direkt GmbH herzustellen, zu warten und instand zu halten. Weitere Informationen über die genaue Ausführung stehen zum Download unter https://www.glasfaser direkt.de/downloads bereit. Die Laufzeit dieser Gestattung beginnt mit der Annahme des Auftrags durch die Glasfaser Direkt GmbH. Eine Kündigung dieser Vereinbarung ist frühestens 10 Jahre nach betriebsbereiter Bereitstellung der Breitbandinfrastruktur mit einer Frist von 6 Wochen m glich (Mindestvertragslaufzeit). Die Glasfaser Direkt GmbH beh lt sich die Ausübung ihrer gesetzlichen Nutzungsrechte vor. Ich best tige, dass ich den Eigentümer des Grundstücks und / oder des Geb udes über den Glasfaser Ausbau informiert habe und dieser der Ma nahme zustimmt. Hier soll sich ein Mouse Over Feld  ffnen, als eine Art Pop Up Fenster mit dem Text anbei'); //$('#input_4_80').prop('disabled', true);

      $("input:radio").each(function (i) {
        if ($(this).is('#choice_4_59_0')) {
          this.checked = true;
        } else if ($(this).is('#choice_4_60_0')) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      });
      $("input:checkbox").each(function (i) {
        if ($(this).is('#choice_4_6_1')) {
          this.checked = true;
        } else if ($(this).is('#choice_4_57_1')) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      });
      /*$('#step-1').hide();
      $('#step-2').show();*/

      $('#step-1').removeClass('active');
      $('#step-2').addClass('active');
      $('html,body').scrollTop(0);
      return false;
    });
    $(".backBtn").click(function () {
      var what = $(this).data("step");
      /*$('.formStep').hide();
      $('.formStepMessage').hide();
      $('#step-'+what).show();*/

      $('.formStep').removeClass('active');
      $('.formStepMessage').hide();
      $('#step-' + what).addClass('active');
      currentStep = what;

      if (currentStep == 4) {
        $('.gform_footer').addClass('active');
      } else {
        $('.gform_footer').removeClass('active');
      }

      $('html,body').scrollTop(0);
      return false;
    });
    $(".nextBtn").click(function () {
      var what = $(this).data("step"); // //console.log(currentStep);

      if (currentStep == 3) {
        checkTextFields();
      }

      if (currentStep == 2) {
        checkRadioFields();
      }

      if ($(this).hasClass('inactive')) {
        if (currentStep == 1) {
          $('#message-' + currentStep).html('Bitte Produkt wählen!');
        } else if (currentStep == 2) {
          // $('#input_4_16').parent().addClass('error');
          $('#message-' + currentStep).html('Bitte füllen Sie die Felder unten aus, um fortzufahren!');
        } else {
          $('#message-' + currentStep).html('Bitte füllen Sie die Felder unten aus, um fortzufahren!');
        }

        $('#message-' + currentStep).show();
      } else {
        // $('#input_4_16').parent().removeClass('error');

        /*$('.formStep').hide();
        $('.formStepMessage').hide();
        $('#step-'+what).show();*/
        $('.formStep').removeClass('active');
        $('.formStepMessage').hide();
        $('#step-' + what).addClass('active');
        currentStep = what;

        if (currentStep == 4) {
          $('.gform_footer').addClass('active');
        } else {
          $('.gform_footer').removeClass('active');
        }

        $('.formStep ul li:nth-child(' + what + ') a').removeClass('inactive');
      }

      $('html,body').scrollTop(0);
      return false;
    });
    $(".formNav a").click(function () {
      var what = $(this).data("step");

      if (currentStep == 3) {
        checkTextFields();
      }

      if (currentStep == 2) {
        checkRadioFields();
      }

      if ($(this).hasClass('inactive')) {
        if (currentStep == 1) {
          $('#message-' + currentStep).html('Bitte Produkt wählen!');
        } else if (currentStep == 2) {
          //$('#input_4_16').parent().addClass('error');
          $('#message-' + currentStep).html('Bitte füllen Sie die Felder unten aus, um fortzufahren!');
        } else {
          $('#message-' + currentStep).html('Bitte füllen Sie die Felder unten aus, um fortzufahren!');
        }

        $('#message-' + currentStep).show();
      } else {
        //$('#input_4_16').parent().removeClass('error');

        /*$('.formStep').hide();
        $('.formStepMessage').hide();
        $('#step-'+what).show();*/
        $('.formStep').removeClass('active');
        $('.formStepMessage').hide();
        $('#step-' + what).addClass('active');
        currentStep = what;

        if (currentStep == 4) {
          $('.gform_footer').addClass('active');
        } else {
          $('.gform_footer').removeClass('active');
        }

        $('.formStep ul li:nth-child(' + what + ') a').removeClass('inactive');
      }

      $('html,body').scrollTop(0);
      return false;
    });
    $("#input_4_10 input").click(function () {
      //$('.formStep#step-2 .nextBtn').removeClass('inactive');
      //$('.formStep ul li:nth-child(3) a').removeClass('inactive');
      $("#input_4_10").parent().removeClass('error');

      if ($(this).is(':checked')) {
        telefonPrice = parseFloat($(this).val()).toFixed(2); //console.log(telefonPrice);

        summarize();
        $('#tableData-telefon').addClass('active');
        var theSelection = $(this).parent().find('label').html();
        theSelection = theSelection.substr(0, theSelection.indexOf('/'));

        if (telefonPrice > 0.00) {
          $('#tableData-telefon .cellData').html(telefonPrice.replace(".", ","));
          $('#tableData-telefon .cellLabel').html('TELEFON PAKET - ' + theSelection);
        } else {
          $('#tableData-telefon .cellData').html("0,00");
          $('#tableData-telefon .cellLabel').html('Ich benötige kein Telefon-Paket');
        }
      }
    });
    $("#input_4_12 input").click(function () {
      //$('.formStep#step-2 .nextBtn').removeClass('inactive');
      //$('.formStep ul li:nth-child(3) a').removeClass('inactive');
      $("#input_4_12").parent().removeClass('error');

      if ($(this).is(':checked')) {
        tvPaket = parseFloat($(this).val()).toFixed(2);
        summarize(); //console.log(tvPaket);

        $('#tableData-tv').addClass('active');
        var theSelection = $(this).parent().find('label').html();
        theSelection = theSelection.substr(0, theSelection.indexOf('/'));
        tvPaket = parseFloat(tvPaket).toFixed(2);

        if (tvPaket > 0.00) {
          $('#tableData-tv .cellData').html(tvPaket.replace(".", ","));
          $('#tableData-tv .cellLabel').html('TV PAKET - ' + theSelection);
        } else {
          $('#tableData-tv .cellData').html("0,00");
          $('#tableData-tv .cellLabel').html('Ich benötige kein TV-Paket');
        }
      }
    });
    /*
    $("#input_4_14 input").click(function() {
     // $('.formStep#step-2 .nextBtn').removeClass('inactive');
     // $('.formStep ul li:nth-child(3) a').removeClass('inactive');
      if($(this).is(':checked')) {     
        
        uploadBoost = parseFloat($(this).val()).toFixed(2);
         $('#tableData-upload').addClass('active');
        var theSelection = $(this).parent().find('label').html();
        //theSelection = theSelection.substr(0, theSelection.indexOf('/')); 
        theSelection = theSelection.substr(0, theSelection.indexOf('<span')); 
        uploadBoost = parseFloat(uploadBoost).toFixed(2);
        summarize();
         
        $('#tableData-upload .cellData').html(uploadBoost.replace(".",","));
        $('#tableData-upload .cellLabel').html(theSelection);
      } else {
        uploadBoost = 0;
         summarize();
     
        $('#tableData-upload').removeClass('active');
        
      }
    });*/

    $("#input_4_67 input").click(function () {
      // $('.formStep#step-2 .nextBtn').removeClass('inactive');
      // $('.formStep ul li:nth-child(3) a').removeClass('inactive');
      $("#input_4_67").parent().removeClass('error');

      if ($(this).is(':checked')) {
        uploadBoost = parseFloat($(this).val()).toFixed(2);
        $('#tableData-upload').addClass('active');
        var theSelection = $(this).parent().find('label').html(); //theSelection = theSelection.substr(0, theSelection.indexOf('/')); 

        theSelection = theSelection.substr(0, theSelection.indexOf('<span'));
        uploadBoost = parseFloat(uploadBoost).toFixed(2);
        summarize();

        if (uploadBoost > 0.00) {
          $('#tableData-upload .cellData').html(uploadBoost.replace(".", ","));
          $('#tableData-upload .cellLabel').html(theSelection);
        } else {
          $('#tableData-upload .cellData').html("0,00");
          $('#tableData-upload .cellLabel').html('Ich benötige keinen Upload-Booster');
        }
      } else {
        uploadBoost = 0;
        summarize();
        $('#tableData-upload').removeClass('active');
      }
    });
    $("#input_4_16 input").click(function () {
      $('.formStep#step-2 .nextBtn').removeClass('inactive');
      $('.formStep ul li:nth-child(3) a').removeClass('inactive');
      $("#input_4_16").parent().removeClass('error');

      if ($(this).is(':checked')) {
        routerAuswahl = parseFloat($(this).val()).toFixed(2);
        $('#tableData-router').addClass('active');
        var theSelection = $(this).parent().find('label').html();
        theSelection = theSelection.substr(0, theSelection.indexOf('<small>'));

        if (theSelection) {
          $('#tableData-router .cellLabel').html('ROUTERAUSWAHL - ' + theSelection);
        } else {
          theSelection = "Ich benutze meinen eigenen Glasfaser-fähigen Router";
          $('#tableData-router .cellLabel').html(theSelection);
        }

        routerAuswahl = parseFloat(routerAuswahl).toFixed(2);
        summarize();
        $('#tableData-router .cellData').html(routerAuswahl.replace(".", ","));
      }
    }); // Personal details

    /*$( "#input_4_17" ).keyup(function() {      // old field
      if($(this).val()=='') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }
      $('#data-1').html($(this).val());      
    });*/

    $("#input_4_64").on('change', function () {
      $('#data-1').html($(this).val());
      $(this).parent().removeClass('error');
    });
    $("#input_4_18").keyup(function () {
      /*if($(this).val()=='') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }*/
      $('#data-2 .first').html($(this).val());
    });
    $("#input_4_66").keyup(function () {
      /*if($(this).val()=='') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }*/
      $('#data-3 .third').html($(this).val());
    });
    $("#input_4_19").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-2 .second').html($(this).val());
    });
    $("#input_4_20").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-2 .third').html($(this).val());
    });
    $("#input_4_21").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-3 .first').html($(this).val());
    });
    $("#input_4_22").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-3 .second').html($(this).val());
    });
    $("#input_4_23").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-4 .first').html($(this).val());
    });
    $("#input_4_24").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-4 .second').html($(this).val());
    });
    $("#input_4_25").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      } // $('#data-4 .second').html($(this).val());

    });
    $("#input_4_76").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      } //$('#data-4 .secondb').html($(this).val());

    });
    $("#input_4_26").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      } //$('#data-4 .second').html($(this).val());

    });
    $("#input_4_28").keyup(function () {
      checkEmail();

      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        checkEmail();
      }
    });
    $("#input_4_29").keyup(function () {
      checkEmail();

      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        checkEmail();
      }
    });
    $("#input_4_31 input").click(function () {
      if ($(this).is(':checked')) {
        bankPrice = parseFloat($(this).val()).toFixed(2);
        $("#choice_4_46_1").attr("checked", false);

        if (bankPrice > 0) {
          summarize();
          $('#data-9').html('Zahlung per Überweisung');
          $('#tableData-bank').addClass('active');
        } else {
          bankPrice = 0.00;
          summarize();
          $('#data-9').html('Bankeinzug');
          $('#tableData-bank').removeClass('active');
        }
      }
    });
    $("#input_4_47 input").click(function () {
      if ($(this).is(':checked')) {
        $('#input_4_47').parent().removeClass('error');

        if ($(this).val() != 0) {
          postPrice = parseFloat($(this).val()).toFixed(2);
          summarize();
          $('#tableData-post').addClass('active');
        } else {
          postPrice = 0.00;
          summarize();
          $('#tableData-post').removeClass('active');
        }
      }
    });
    $("#input_4_68 input").click(function () {
      $('#input_4_68').parent().removeClass('error');

      if ($('#choice_4_68_1').is(':checked')) {
        $('.hideInactiveRadios input').each(function (i) {
          this.disabled = false;
          $(this).parent().parent().addClass('active');
          $('#field_4_75').show();
        });
      } else {
        $('.hideInactiveRadios input').each(function (i) {
          this.disabled = true;
          $(this).parent().parent().removeClass('active');
          $('#field_4_75').hide();
        });
      }
    });
    $("#input_4_33 input").click(function () {
      if ($(this).is(':checked')) {
        $('.hideInactive input').each(function (i) {
          this.disabled = false;
          $(this).parent().parent().addClass('active');
        });
        $('.hideInactive select').each(function (i) {
          this.disabled = false;
          $(this).parent().parent().addClass('active');
        });
      } else {
        $('.hideInactive input').each(function (i) {
          this.disabled = true;
          $(this).parent().parent().removeClass('active');
        });
        $('.hideInactive select').each(function (i) {
          this.disabled = true;
          $(this).parent().parent().removeClass('active');
        });
      }
    }); // invoice details

    /*$( "#input_4_35" ).keyup(function() {     // old field
      $('#invoice-2').show();  
      if($(this).val()=='') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }
      $('#data-5').html($(this).val());      
    });*/

    $("#input_4_63").on('change', function () {
      $('#data-5').html($(this).val());
      $(this).parent().removeClass('error');
    });
    $("#field_4_57 input").on('change', function () {
      $("#field_4_57 input").prop("checked", true);
    });
    $("#input_4_36").keyup(function () {
      $('#invoice-2').show();

      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-6 .first').html($(this).val());
    });
    $("#input_4_37").keyup(function () {
      $('#invoice-2').show();

      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-6 .second').html($(this).val());
    });
    $("#input_4_38").keyup(function () {
      $('#invoice-2').show();

      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-6 .third').html($(this).val());
    });
    $("#input_4_39").keyup(function () {
      $('#invoice-2').show();

      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-8 .first').html($(this).val());
    });
    $("#input_4_40").keyup(function () {
      $('#invoice-2').show();

      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-8 .second').html($(this).val());
    });
    $("#input_4_41").keyup(function () {
      $('#invoice-2').show();

      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-7 .first').html($(this).val());
    });
    $("#input_4_42").keyup(function () {
      $('#invoice-2').show();

      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-7 .second').html($(this).val());
    });
    $("#input_4_65").keyup(function () {
      $('#invoice-2').show();

      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-7 .third').html($(this).val());
    });
    $("#input_4_43").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-10 .first').html($(this).val());
    });
    $("#input_4_44").keyup(function () {
      if ($(this).val() == '') {
        $(this).parent().addClass('error');
      } else {
        $(this).parent().removeClass('error');
      }

      $('#data-11 .first').html($(this).val());
    });
    $('#input_4_31 input').click(function () {
      $('#input_4_31').parent().removeClass('error'); //choice_4_31_1

      if ($('#choice_4_31_1').is(':checked')) {
        $('#field_4_46').hide();
        $('#input_4_46').parent().removeClass('error');
      } else {
        $('#field_4_46').show();
      }
    });
    $('#input_4_46 input').click(function () {
      $('#input_4_46').parent().removeClass('error');
      $('#input_4_31').parent().removeClass('error');
    });
    $('#input_4_49 input').click(function () {
      $('#input_4_49').parent().removeClass('error');

      if ($('#choice_4_49_0').is(':checked')) {
        $('#field_4_51').hide();
        $('#field_4_52').hide();
        $('#field_4_53').hide();
        $('#input_4_52').parent().removeClass('error');
        $('#input_4_53').parent().removeClass('error');
        $('#choice_4_52_0').prop('checked', false);
        $('#choice_4_52_1').prop('checked', false);
        $('#choice_4_52_2').prop('checked', false);
        $('#choice_4_53_0').prop('checked', false);
        $('#choice_4_53_1').prop('checked', false);
        $('#choice_4_53_2').prop('checked', false);
      } else {
        $('#field_4_51').show();
        $('#field_4_52').show();
        $('#field_4_53').show();
      }
    });
    $('#input_4_52 input').click(function () {
      $('#input_4_52').parent().removeClass('error');
    });
    $('#input_4_53 input').click(function () {
      $('#input_4_53').parent().removeClass('error');
    }); //$("#choice_4_57_1").attr("checked", true);

    $('#input_4_56 #choice_4_56_0').click(function () {
      $('#input_4_56').parent().removeClass('error');
      $('#field_4_57').removeClass('active'); //$("#choice_4_57_1").attr("checked", false);
    });
    $('#input_4_56 #choice_4_56_1').click(function () {
      $('#input_4_56').parent().removeClass('error');
      $('#field_4_57').addClass('active'); //$("#choice_4_57_1").attr("checked", true);
    });
    $('#input_4_59 input').click(function () {
      $('#input_4_59').parent().removeClass('error');
    });
    $('#input_4_60 input').click(function () {
      $('#input_4_60').parent().removeClass('error');
    });
    $('#input_4_62 input').click(function () {
      $('#input_4_62').parent().removeClass('error');
      $('.hider').hide();
    });
  }

  function summarize() {
    monthlyprice = parseFloat(productPrice) + parseFloat(telefonPrice) + parseFloat(tvPaket) + parseFloat(uploadBoost) + parseFloat(bankPrice) + parseFloat(postPrice);
    onceprice = parseFloat(baseInstall) + parseFloat(baseNet) + parseFloat(routerAuswahl);
    monthlyprice = parseFloat(monthlyprice).toFixed(2);
    onceprice = parseFloat(onceprice).toFixed(2);
    $('.tableRow.last .einmalig').html(onceprice.replace(".", ","));
    $('.tableRow.last .monat').html(monthlyprice.replace(".", ","));
  }

  var allgood = true;
  var allgoodRadios = true;

  function checkRadioFields() {
    var allgoodRadios = true;

    if ($('#input_4_10 input').is(':checked')) {} else {
      allgoodRadios = false;
      $('#input_4_10').parent().addClass('error');
    }

    if ($('#input_4_12 input').is(':checked')) {} else {
      allgoodRadios = false;
      $('#input_4_12').parent().addClass('error');
    }

    if ($('#input_4_67 input').is(':checked')) {} else {
      allgoodRadios = false;
      $('#input_4_67').parent().addClass('error');
    }

    if ($('#input_4_16 input').is(':checked')) {} else {
      allgoodRadios = false;
      $('#input_4_16').parent().addClass('error');
    }

    if (allgoodRadios) {
      $('.formStep ul li:nth-child(3) a').removeClass('inactive');
      $('.formStep#step-2 .nextBtn').removeClass('inactive');
      $('#message-2').hide();
    } else {
      $('.formStep ul li:nth-child(3) a').addClass('inactive');
      $('.formStep#step-2 .nextBtn').addClass('inactive');
      $('#message-2').html('Bitte füllen Sie die Felder unten aus, um fortzufahren!');
      $('#message-2').show();
    }
  }

  function checkTextFields() {
    allgood = true;

    if ($('#choice_4_49_1').is(':checked')) {
      if ($('#input_4_52 input').is(':checked') && $('#input_4_53 input').is(':checked')) {
        /*allgood = true;
        $('#input_4_49').parent().removeClass('error');
        $('#input_4_52').parent().removeClass('error');
        $('#input_4_53').parent().removeClass('error');*/
      } else if ($('#input_4_52 input').is(':checked') && $('#input_4_53 input').is(':not(:checked)')) {
        allgood = false; //console.log('Gebaude 1 input_4_52 false 1');

        $('#input_4_53').parent().addClass('error');
        $('#input_4_52').parent().removeClass('error');
      } else if ($('#input_4_52 input').is(':not(:checked)') && $('#input_4_53 input').is(':checked')) {
        allgood = false; //console.log('Gebaude 2 input_4_52 false 2');

        $('#input_4_52').parent().addClass('error');
        $('#input_4_53').parent().removeClass('error');
      } else {
        allgood = false; //console.log('Gebaude 3 input_4_52 false 3');

        $('#input_4_52').parent().addClass('error');
        $('#input_4_53').parent().addClass('error');
      }
    } else if ($('#choice_4_49_0').is(':checked')) {
      /*allgood = true;
      $('#input_4_52').parent().removeClass('error');
      $('#input_4_53').parent().removeClass('error');*/
    } else {
      allgood = false; //console.log('Gebaude 4 input_4_52 false 4');

      $('#input_4_49').parent().addClass('error');
      $('#input_4_52').parent().addClass('error');
      $('#input_4_53').parent().addClass('error');
    } ////console.log('26 '+allgood);


    if ($('#input_4_68 input').is(':checked')) {//console.log('new2');
    } else {
      allgood = false; //console.log('new');

      $('#input_4_68').parent().addClass('error');
    }

    if ($('#input_4_56 input').is(':checked')) {
      if ($('#choice_4_56_1').is(':checked')) {
        if ($('#input_4_57 input').is(':not(:checked)')) {
          allgood = false;
          $('#input_4_57').parent().addClass('error');
          console.log("Grundstuck 2 ");
        }
      }
    } else {
      $('#input_4_56').parent().addClass('error');
      allgood = false;
      console.log("Grundstuck 1 ");
    }

    if ($('#input_4_47 input').is(':checked')) {} else {
      allgood = false;
      $('#input_4_47').parent().addClass('error');
      console.log("Rechnungs ");
    }

    if ($('#input_4_31 input').is(':checked')) {
      if ($('#choice_4_31_0').is(':checked')) {
        if ($('#choice_4_31_0').is(':checked') && $('#choice_4_46_1').is(':checked')) {
          /*allgood = true;
                  $('#input_4_46').parent().removeClass('error');
          $('#input_4_31').parent().removeClass('error');*/
        } else {
          $('#input_4_31').parent().addClass('error');
          $('#input_4_46').parent().addClass('error');
          allgood = false; //console.log('Bank checkbox 1 input_4_31 false 1');
        }
      } else {
        if ($('#choice_4_31_1').is(':checked')) {
          /*
          allgood = true;
          $('#input_4_46').parent().removeClass('error');
          $('#input_4_31').parent().removeClass('error');*/
        } else {
          $('#input_4_31').parent().addClass('error');
          allgood = false; //console.log('Bank checkbox 2 input_4_31 false 2');
        }
      }
    } else {
      $('#input_4_31').parent().addClass('error');
      allgood = false; //console.log('Bank checkbox 3 input_4_31 false 3');
    } ////console.log('22 '+allgood);


    if ($('#input_4_64').val() == '') {
      $('#input_4_64').parent().addClass('error');
      allgood = false; //console.log('Bank checkbox 4 input_4_64 false ');
    }

    if ($('#input_4_46 input').is(':checked')) {
      if ($('#choice_4_31_0').is(':checked')) {
        /*allgood = true;
        $('#input_4_46').parent().removeClass('error');
        $('#input_4_31').parent().removeClass('error');*/
      } else {
        allgood = false; //console.log('Bank checkbox 5 input_4_46 false 1');

        $('#input_4_31').parent().addClass('error');
      }
    } else {
      if ($('#choice_4_31_1').is(':checked')) {
        /*allgood = true;
        $('#input_4_46').parent().removeClass('error');
        $('#input_4_31').parent().removeClass('error');*/
      } else {
        allgood = false; //console.log('Bank checkbox 6 input_4_46 false 2');

        $('#input_4_46').parent().addClass('error');
      }
    } ////console.log('1 '+allgood);


    if ($('#input_4_19').val() == '') {
      $('#input_4_19').parent().addClass('error');
      allgood = false; //console.log('Vorname input_4_19 false ');
    } ////console.log('2 '+allgood);


    if ($('#input_4_20').val() == '') {
      $('#input_4_20').parent().addClass('error');
      allgood = false; //console.log('Nachname input_4_20 false ');
    } ////console.log('3 '+allgood);


    if ($('#input_4_21').val() == '') {
      $('#input_4_21').parent().addClass('error');
      allgood = false; //console.log('Strasse input_4_21 false ');
    } ////console.log('4 '+allgood);


    if ($('#input_4_22').val() == '') {
      $('#input_4_22').parent().addClass('error');
      allgood = false; //console.log('Hausnummer input_4_23 false ');
    } ////console.log('5 '+allgood);


    if ($('#input_4_23').val() == '') {
      $('#input_4_23').parent().addClass('error');
      allgood = false; //console.log('Plz input_4_23 false ');
    } ////console.log('6 '+allgood);


    if ($('#input_4_24').val() == '') {
      $('#input_4_24').parent().addClass('error');
      allgood = false; //console.log('Ort input_4_24 false ');
    } ////console.log('7 '+allgood);


    if ($('#input_4_25').val() == '') {
      $('#input_4_25').parent().addClass('error');
      allgood = false; //console.log('Mobil input_4_25 false ');
    }

    if ($('#input_4_76').val() == '') {
      $('#input_4_76').parent().addClass('error');
      allgood = false; //console.log('Mobil input_4_76 false ');
    } ////console.log('8 '+allgood);


    if ($('#input_4_26').val() == '') {
      $('#input_4_26').parent().addClass('error');
      allgood = false; //console.log('Geburstag input_4_26 false ');
    } ////console.log('9 '+allgood);


    if ($('#input_4_28').val() == '') {
      $('#input_4_28').parent().addClass('error');
      allgood = false; //console.log('Email 1 input_4_28 false ');
    } ////console.log('10 '+allgood);


    if ($('#input_4_29').val() == '') {
      $('#input_4_29').parent().addClass('error');
      allgood = false; //console.log('Email 2 input_4_29 false ');
    } ////console.log('11 '+allgood);


    if ($('#choice_4_33_1').is(':checked')) {
      if ($('#input_4_63').val() == '') {
        $('#input_4_63').parent().addClass('error');
        allgood = false; //console.log('Invoice anrede input_4_63 false ');
      } ////console.log('13 '+allgood);


      if ($('#input_4_37').val() == '') {
        $('#input_4_37').parent().addClass('error');
        allgood = false; //console.log('Invoice vorname input_4_37 false ');
      } ////console.log('14 '+allgood);


      if ($('#input_4_38').val() == '') {
        $('#input_4_38').parent().addClass('error');
        allgood = false; //console.log('Invoice nachname input_4_38 false ');
      } ////console.log('15 '+allgood);


      if ($('#input_4_39').val() == '') {
        $('#input_4_39').parent().addClass('error');
        allgood = false; //console.log('Invoice PLZ input_4_39 false ');
      } ////console.log('16 '+allgood);


      if ($('#input_4_40').val() == '') {
        $('#input_4_40').parent().addClass('error');
        allgood = false; //console.log('Invoice Ort input_4_40 false ');
      } ////console.log('17 '+allgood);


      if ($('#input_4_41').val() == '') {
        $('#input_4_41').parent().addClass('error');
        allgood = false; //console.log('Invoice Strasse input_4_41 false ');
      } ////console.log('18 '+allgood);


      if ($('#input_4_42').val() == '') {
        $('#input_4_42').parent().addClass('error');
        allgood = false; //console.log('Invoice Hausnummer input_4_42 false ');
      } ////console.log('19 '+allgood);

    }

    if ($('#input_4_43').val() == '') {
      // IBAN
      $('#input_4_43').parent().addClass('error');
      allgood = false; //console.log('IBAN input_4_43 false ');
    } ////console.log('20 '+allgood);


    if ($('#input_4_44').val() == '') {
      // BIC
      $('#input_4_44').parent().addClass('error');
      allgood = false; //console.log('BIC input_4_44 false ');
    } ////console.log('21 '+allgood);


    if (allgood) {
      $('.formStep ul li:nth-child(4) a').removeClass('inactive');
      $('.formStep#step-3 .nextBtn').removeClass('inactive');
      $('#message-3').hide();
    } else {
      $('.formStep ul li:nth-child(4) a').addClass('inactive');
      $('.formStep#step-3 .nextBtn').addClass('inactive');
      $('#message-3').html('Bitte füllen Sie die Felder unten aus, um fortzufahren!');
      $('#message-3').show();
    }
  }

  function checkEmail() {
    var first = $('#input_4_28').val();
    var second = $('#input_4_29').val();

    if (first != second) {
      $('#input_4_28').parent().addClass('error');
      $('#input_4_29').parent().addClass('error');
    } else {
      $('#input_4_28').parent().removeClass('error');
      $('#input_4_29').parent().removeClass('error');
    }
  }
});